import { getPipelineCounts } from "../../modules/talentPipeline/utils/pipelineMetrics";

export function computeTalentMetrics(pipelineRows = [], invites = []) {
  return getPipelineCounts(pipelineRows, invites);
}